export default "__VITE_ASSET__J3nSX8AI__"